import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import "./UploadCSV.css";
import { plantUIDPrintSummary } from "../Header/service";
import Loader from "../../components/Loader/Loader";
import { userFootFallTracking } from "../FootFallReport/services";

const UploadCSV = () => {
  const [csvData, setCsvData] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isLoader, setLoader] = useState(false);
  const [dynamicHeaders, setDynamicHeaders] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const navigate = useNavigate();

  useEffect(() => {
    handleCSVData();
  }, [page, rowsPerPage]);

  const handleCSVData = async () => {
    const params = {
      page: page + 1,
      rowsPerPage: rowsPerPage,
    };

    try {
      setLoader(true);
      const resp = await plantUIDPrintSummary(params);
      if (resp.status == 200 || resp.status == 201) {
        setCsvData(resp.data);
        // Extract dynamic headers from the first result
        if (resp.data?.results?.length > 0) {
          const keys = Object.keys(resp.data.results[0]);
          setDynamicHeaders(keys);
        }
        setLoader(false);
      }
    } catch (err) {
      setCsvData([]);
      setLoader(false);
      console.log(err);
    }
  };

  useEffect(() => {
    let intervalId = null;

    const callUserFootFallTracking = () => {
      const moduleList = JSON.parse(localStorage.getItem("moduleList"));
      if (moduleList) {
        const module = moduleList.find((m) => m.name === "UID Print Summary");
        if (module) {
          const params = { module_id: module.id };
          try {
            userFootFallTracking(params);
          } catch (error) {
            console.error("Error calling userFootFallTracking:", error);
          }
        }
      }
    };

    const startTracking = () => {
      if (!intervalId) {
        console.log("▶️ Start API interval");
        callUserFootFallTracking(); // call immediately
        intervalId = setInterval(callUserFootFallTracking, 5 * 60 * 1000);
      }
    };

    const stopTracking = () => {
      if (intervalId) {
        console.log("⏹ Stop API interval");
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopTracking(); // stop when tab hidden/minimized
      } else {
        startTracking(); // resume when tab active
      }
    };

    // Setup listener
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Start tracking immediately if tab is visible
    if (!document.hidden) {
      startTracking();
    }

    return () => {
      stopTracking();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  return (
    <div className="containerWrap">
      <Container maxWidth="xxl">
        <div className="packingHeader-wrap">
          <div className="packingTitle-wrap">
            <KeyboardBackspaceIcon
              onClick={() => navigate("/dashboard")}
              className="backArrow"
            />
            <Typography
              variant="h5"
              className="packingTitle"
              gutterBottom
              onClick={() => navigate("/dashboard")}
            >
              ASTRAL PLANTS UID PRINTING
            </Typography>
          </div>
        </div>
        <div className="packinghistory-table csv-table">
          <Table>
            <TableHead>
              <TableRow>
                {dynamicHeaders.map((header, index) => (
                  <TableCell key={index}>
                    {header === "month" ? "Months" : header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody className="packingHistory-tablebody">
              {csvData?.results?.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {dynamicHeaders.map((header, cellIndex) => (
                    <TableCell key={cellIndex}>
                      {row[header] !== null && row[header] !== undefined
                        ? row[header]
                        : "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          className="table-pagination"
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={csvData?.count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Container>
      {isLoader && (
        <>
          <Loader />
        </>
      )}
    </div>
  );
};

export default UploadCSV;
